import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SbMenuComponent } from './sb-menu/sb-menu.component';
import { PopoverDirective } from './sb-menu/popover/popover.directive';
import { SharedModule } from '../shared/shared.module';
import { SbProfileComponent } from './sb-menu/sb-profile/sb-profile.component';
import { PopoverTriggerDirective } from './sb-menu/popover/popover-trigger.directive';
import { PopoverContainerDirective } from './sb-menu/popover/popover-container.directive';
import { SbActionsComponent } from './sb-menu/sb-actions/sb-actions.component';
import { SbFilterComponent } from './sb-menu/sb-filter/sb-filter.component';
import { PopoverOptionDirective } from './sb-menu/popover/popover-option.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { SbFooterComponent } from './sb-footer/sb-footer.component';
import { SessionModule } from './session/session.module';
import { IconsModule } from '../shared/icons/icons.module';
import { SbImpersonationNoticeComponent } from '../pages/admin/impersonate/components/sb-impersonation-notice/sb-impersonation-notice.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TestSelectorDirective } from '../shared/directives/test-selector.directive';
import { SbTooltipInfoComponent } from '../shared/components/sb-tooltip-info/sb-tooltip-info.component';

@NgModule({
    declarations: [
        SbMenuComponent,
        PopoverDirective,
        SbProfileComponent,
        PopoverTriggerDirective,
        PopoverContainerDirective,
        SbActionsComponent,
        SbFilterComponent,
        PopoverOptionDirective,
        SbFooterComponent
    ],
    exports: [SbMenuComponent, SbFooterComponent, SharedModule],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        SessionModule,
        SharedModule,
        IconsModule,
        SbImpersonationNoticeComponent,
        MatTooltipModule,
        TestSelectorDirective,
        SbTooltipInfoComponent
    ]
})
export class CoreModule {}
